import { Link } from 'react-router-dom';
import { ROUTES } from '../Routes';
import card from '../assets/bestportugalcasino.png'
import plus18 from '../assets/18plus-1.png'

const Footer = () => {

  return (
    <div
      data-elementor-type="footer"
      data-elementor-id="3216"
      className="elementor elementor-3216 elementor-location-footer"
      data-elementor-post-type="elementor_library"
    >
      <div className="elementor-element elementor-element-21cbbee e-con-full e-flex e-con e-parent" data-id="21cbbee" data-element_type="container">
        <div className="elementor-element elementor-element-8cfd9ea e-flex e-con-boxed e-con e-child" data-id="8cfd9ea" data-element_type="container" data-settings='{"background_background":"classic"}'>
          <div className="e-con-inner">

            {/* Ícone 18+ */}
            <div className="elementor-element elementor-element-11b37c0 elementor-widget__width-initial elementor-widget elementor-widget-image" data-id="11b37c0" data-element_type="widget" data-widget_type="image.default">
              <div className="elementor-widget-container">
                <img
                  width="261"
                  height="258"
                  src={plus18}
                  className="attachment-large size-large wp-image-3272"
                  alt=""
                />
              </div>
            </div>

            {/* Logo e Título */}
            <div className="elementor-element elementor-element-458886f e-con-full e-flex e-con e-child" data-id="458886f" data-element_type="container">
              <div className="elementor-element elementor-element-9ba22f0 elementor-widget__width-initial elementor-widget elementor-widget-theme-site-logo elementor-widget-image" data-id="9ba22f0" data-element_type="widget" data-widget_type="theme-site-logo.default">
                <div className="elementor-widget-container">
                  <Link to={ROUTES.BASE}>
                    <img
                      width="512"
                      height="512"
                      src={card}
                      className="attachment-full size-full wp-image-3542"
                      alt=""
                    />
                  </Link>
                </div>
              </div>
              <div className="elementor-element elementor-element-18a7758 elementor-widget elementor-widget-theme-site-title elementor-widget-heading" data-id="18a7758" data-element_type="widget" data-widget_type="theme-site-title.default">
                <div className="elementor-widget-container">
                  <span className="elementor-heading-title elementor-size-default">
                    <Link to={ROUTES.BASE}>Casinonlineportugal</Link>
                  </span>
                </div>
              </div>
            </div>

            {/* Descrição Sobre Nós */}
            <div className="elementor-element elementor-element-224184d elementor-widget__width-initial elementor-widget elementor-widget-text-editor" data-id="224184d" data-element_type="widget" data-widget_type="text-editor.default">
              <div className="elementor-widget-container">
                <p>Somos o seu guia de confiança para comparar os melhores casinos online legais em Portugal. No Casinonlineportugal, analisamos apenas plataformas 100% licenciadas e regulamentadas pela SRIJ. A nossa missão é ajudar os jogadores a escolher casinos seguros, justos e fiáveis — sempre em conformidade com a lei portuguesa.<br />Não operamos casinos. Somos especialistas em análises, comparações imparciais e recomendações transparentes.</p>
              </div>
            </div>

            {/* Links Externos (GambleAware/SRIJ) */}
            <div className="elementor-element elementor-element-312af22 elementor-icon-list--layout-inline elementor-align-center elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="312af22" data-element_type="widget" data-widget_type="icon-list.default">
              <div className="elementor-widget-container">
                <ul className="elementor-icon-list-items elementor-inline-items">
                  <li className="elementor-icon-list-item elementor-inline-item">
                    <a href="https://www.gambleaware.org/" target="_blank" rel="noreferrer">
                      <span className="elementor-icon-list-icon">
                        <svg aria-hidden="true" className="e-font-icon-svg e-fas-external-link-alt" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                          <path d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"></path>
                        </svg>
                      </span>
                      <span className="elementor-icon-list-text">GambleAware.org</span>
                    </a>
                  </li>
                  <li className="elementor-icon-list-item elementor-inline-item">
                    <a href="https://www.srij.turismodeportugal.pt/pt/jogos-e-apostas-online/entidades-licenciadas" target="_blank" rel="noreferrer">
                      <span className="elementor-icon-list-icon">
                        <svg aria-hidden="true" className="e-font-icon-svg e-fas-external-link-alt" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                          <path d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"></path>
                        </svg>
                      </span>
                      <span className="elementor-icon-list-text">SRIJ</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Copyright e Políticas */}
            <div className="elementor-element elementor-element-ca80a92 e-con-full e-flex e-con e-child" data-id="ca80a92" data-element_type="container">
              <div className="elementor-element elementor-element-c855339 elementor-widget elementor-widget-text-editor" data-id="c855339" data-element_type="widget" data-widget_type="text-editor.default">
                <div className="elementor-widget-container">
                  Copyright © 2026 Casinonlineportugal.site. All rights reserved.
                </div>
              </div>
              <div className="elementor-element elementor-element-8263213 elementor-icon-list--layout-inline elementor-mobile-align-center elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="8263213" data-element_type="widget" data-widget_type="icon-list.default">
                <div className="elementor-widget-container">
                  <ul className="elementor-icon-list-items elementor-inline-items">
                    <li className="elementor-icon-list-item elementor-inline-item">
                      <Link to={ROUTES.PRIVACY_POLICY}>
                        <span className="elementor-icon-list-text">Politique de Confidentialité</span>
                      </Link>
                    </li>
                    <li className="elementor-icon-list-item elementor-inline-item">
                      <Link to={ROUTES.TERMS_AND_CONDITIONS}>
                        <span className="elementor-icon-list-text">Termos e Condições</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Aviso de Responsabilidade Final */}
            <div className="elementor-element elementor-element-bc4b84d elementor-widget elementor-widget-text-editor" data-id="bc4b84d" data-element_type="widget" data-widget_type="text-editor.default">
              <div className="elementor-widget-container">
                <p>Este site é destinado apenas a maiores de 18 anos. Para utilizar os nossos serviços ou participar em jogos de azar, é obrigatório ter idade legal. O jogo deve ser visto como uma forma de entretenimento e não como uma solução financeira. Jogue com responsabilidade. Se acredita que o jogo está a afetar a sua vida ou a de alguém próximo, procure apoio junto de entidades especializadas em jogo responsável.</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;